function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomShowerOnlyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.38c0-1.23.37-2.06.88-2.57C13.39 5.29 14.11 5 15 5c1.33 0 2.36.91 2.49 2.23-1.75.56-2.97 2.04-3.36 3.54-.09.34-.13.67-.13 1v1h9.36v-1c0-.33-.03-.67-.09-1-.32-1.82-1.54-3.54-3.8-3.75C19.24 4.67 17.33 3 14.99 3c-1.34 0-2.61.46-3.55 1.41-.94.96-1.45 2.32-1.45 3.97V27H4v2h24v-2H12V8.38zM19 9c.87 0 1.39.33 1.74.77.21.27.38.62.49 1h-4.98C16.69 9.85 17.68 9 19 9zm.68 8v-3h-2v3h2zM16 17h-2v-3h2v3zm5.36 0h2v-3h-2v3z",
    fill: props.color
  }));
}

export default SvgIconRoomShowerOnlyFilled;